<template>
    <div class="user-chat-topbar-wrapper">
        <div v-if="!isSearchOpen" class="p-3 p-lg-4 border-bottom user-chat-topbar">
            <div class="row align-items-center header_msg_box">
                <div class="col-8 col-lg-6">
                    <div class="d-flex align-items-center">
                        <div class="d-block d-lg-none me-2 ms-0">
                            <a href="#" @click.prevent="isTeamMode ? internalChatStore.closeChat() : chatStore.closeChat()" class="user-chat-remove text-muted font-size-16 p-2">
                                <i class="ri-arrow-left-s-line"></i>
                            </a>
                        </div>

                        <div class="me-3 ms-0 header_img" :class="{ 'cursor-pointer': !isTeamMode }" @click="!isTeamMode && chatStore.toggleProfile()">
                            <AvatarField
                                :foto="displayAvatar"
                                :is-group="isGroup"
                                class="rounded-circle avatar-xs"
                            />
                        </div>

                        <div class="flex-grow-1 overflow-hidden" :class="{ 'cursor-pointer': !isTeamMode }" @click="!isTeamMode && chatStore.toggleProfile()">
                            <span v-if="contact.nomeClienteAxion" class="mb-1 check_grpro_text d-inline-flex align-items-center text-truncate" style="max-width: 200px;" :title="contact.nomeClienteAxion">
                                <i class="ri-vip-crown-fill"></i>
                                <span class="text-truncate">{{ contact.nomeClienteAxion }}</span>
                            </span>
                            <h5 class="font-size-16 mb-0 name_header">
                                <span class="text-truncate" :title="contact.name">{{ contact.name }}</span>
                            </h5>

                            <p
                                v-if="presencaDigitando"
                                class="font-size-14 m-0 text-truncate presenca-header"
                                :style="presencaDigitando.cor ? { color: presencaDigitando.cor } : undefined"
                                :title="presencaDigitando.texto"
                            >
                                {{ presencaDigitando.texto }}
                            </p>
                            <p v-else-if="isGroup" class="text-muted font-size-14 m-0 text-truncate">
                                {{ groupParticipantsSummary }}
                            </p>
                            <p
                                v-else-if="internalChatStore.isInternalChatMode"
                                class="mb-0 font-size-12"
                                :class="isOnline ? 'text-success' : 'text-muted'"
                            >
                                {{ isOnline ? 'Online' : 'Offline' }}
                            </p>
                            <p v-else class="text-muted font-size-14 m-0">
                                <span v-if="contact.atendentes && contact.atendentes.length > 0">
                                    Em atendimento com {{ contact.atendentes[0].name }}
                                </span>
                                <span v-else>
                                    {{ contact.status }}
                                </span>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="col-4 col-lg-6">
                    <ul class="list-inline user-chat-nav text-end mb-0">

                        <!--
                            Contador da janela de atendimento (CSW). O gate é a CAPACIDADE
                            Cloud API do inbox (inclui coexistência híbrida), não a restrição
                            `inboxOfSelectedChatIsOfficialWpp` — que num híbrido saudável é
                            false e escondia o contador justamente de quem precisa dele.
                        -->
                        <div v-if="__debugForce_showInteractionWindowCountdown || (chatStore.inboxOfSelectedChatSuportaTemplatesMeta && countdown.show)"
                             class="csw-timer" :class="{ 'is-urgent': cswUrgente }"
                             v-tooltip="'Tempo restante da janela de atendimento de 24h'">
                          <i class="ri-time-line"></i>
                          <span class="csw-timer-value">
                            <template v-if="countdown.seconds != undefined">
                              <template v-if="countdown.hours">{{ String(countdown.hours).padStart(2, '0') }}h</template>
                              <template v-if="countdown.hours || countdown.minutes">{{ String(countdown.minutes).padStart(2, '0') }}m</template>
                              <template v-if="!countdown.hours">{{ String(countdown.seconds).padStart(2, '0') }}s</template>
                            </template>
                            <template v-else>Janela fechada</template>
                          </span>
                        </div>

                        <div v-if="showNoAiBadge" class="no-ai-badge d-inline-flex align-items-center justify-content-center me-2"
                            v-tooltip="'Integração de IA desativada para este contato'">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2"/>
                                <path d="M11.412 7.39957C11.6326 6.86724 12.3672 6.86722 12.5878 7.39957L12.9042 8.16324C13.4441 9.46665 14.4521 10.5083 15.7186 11.0714L16.6151 11.4699C17.1283 11.6984 17.1284 12.4457 16.6151 12.674L15.6649 13.0959C14.4305 13.645 13.4408 14.6488 12.8915 15.9093L12.5839 16.6164C12.3582 17.1337 11.6415 17.1338 11.4159 16.6164L11.1083 15.9093C10.559 14.6487 9.56943 13.645 8.33485 13.0959L7.38465 12.674C6.8715 12.4457 6.87171 11.6985 7.38465 11.4699L8.28114 11.0714C9.54755 10.5083 10.5547 9.46665 11.0946 8.16324L11.412 7.39957Z" fill="currentColor"/>
                                <line x1="6.06207" y1="16.9641" x2="8.49568" y2="14.7353" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                                <line x1="15.0621" y1="8.96411" x2="17.6432" y2="6.60024" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                        </div>

                        <div v-permission="'inbox.ver_agendamentos'" v-if="!internalChatStore.isInternalChatMode" class="me-3 ms-3 cursor-pointer position-relative icon-container"
                            @click="isGroup ? scheduleStore.openManager(contact.id, contact.name, true) : scheduleStore.openManager(contact.idContato || contact.id, contact.name)"

                            v-tooltip="'Agendamentos'">

                            <i class="ri-calendar-event-line font-size-22 transition-colors"
                            :class="(isGroup ? scheduleStore.hasPendingScheduleGrupo(contact.id) : scheduleStore.hasPendingSchedule(contact.idContato || contact.id)) ? 'text-primary' : 'text-muted'">
                            </i>

                            <div v-if="isGroup ? scheduleStore.hasPendingScheduleGrupo(contact.id) : scheduleStore.hasPendingSchedule(contact.idContato || contact.id)" class="pulse-ring"></div>
                        </div>

                        <li class="list-inline-item me-2 ms-0" title="Pesquisar Mensagens">
                            <button type="button" class="btn nav-btn" @click="openSearchMode">
                                <i class="ri-search-line"></i>
                            </button>
                        </li>

                        <!--
                          Ligar para o contato da conversa. Só aparece com as DUAS
                          condições: plataforma que transporta voz (whiz-wa-go) e
                          ligações habilitadas nesta inbox. Sem o segundo filtro o
                          botão apareceria para todo mundo e devolveria 400, já que
                          ligação é opt-in por número (risco de ban).
                        -->
                        <li v-if="podeLigar" class="list-inline-item me-2 ms-0" title="Ligar">
                            <button
                                type="button"
                                class="btn nav-btn"
                                :disabled="discandoNestaInbox"
                                v-tooltip="discandoNestaInbox ? 'Discando…' : 'Ligar para este contato'"
                                @click="handleLigar"
                            >
                                <i :class="discandoNestaInbox ? 'ri-loader-4-line' : 'ri-phone-line'"></i>
                            </button>
                        </li>

                        <li class="list-inline-item me-2 ms-0 d-none" title="Sala de Vídeo">
                            <button type="button" class="btn nav-btn" @click="handleVideoCall">
                                <i class="ri-vidicon-line"></i>
                            </button>
                        </li>

                        <li class="list-inline-item" v-if="!isTeamMode && podeIntervirNoAgente">
                            <DropdownField :distance="6" placement="bottom-end" strategy="fixed" :triggers="['click']">
                                <template #default>
                                    <button class="btn nav-btn dropdown-toggle more_option" type="button" title="Mais Opções" @click.stop="handleDropdownOpen">
                                        <i class="ri-more-fill"></i>
                                    </button>
                                </template>

                                <template #popper>
                                    <div class="dropdown-menu-v">

                                        <template v-if="isGroup">
                                            <li v-permission="'conta.vincular_etiquetas'">
                                                <button type="button" class="dropdown-item-v" @click="() => { chatStore.setChatToLinkTags(chatStore.activeChat); $emit('open-link-tag-modal') }">
                                                    <i class="ri-price-tag-3-line me-2"></i> <span>Etiquetas</span>
                                                </button>
                                            </li>
                                            <button v-if="chatStore.activeChat" type="button" class="dropdown-item-v" v-close-popper @click="PromptToAlternarSilencioGrupo(chatStore.activeChat, chatStore)">
                                                <i :class="grupoAtivoSilenciado ? 'ri-notification-3-line' : 'ri-notification-off-line'" class="me-2"></i>
                                                <span>{{ grupoAtivoSilenciado ? 'Reativar notificações' : 'Silenciar' }}</span>
                                            </button>
                                            <button type="button" class="dropdown-item-v" v-close-popper @click="openBlockModal">
                                                <i class="ri-user-forbid-line me-2"></i> <span>Bloquear usuários</span>
                                            </button>
                                            <div v-permission="permApagarGrupo" :key="`divider-apagar-grupo-${idInboxAtivo}`" class="dropdown-divider-v"></div>
                                            <button v-permission="permApagarGrupo" :key="`apagar-grupo-${idInboxAtivo}`" type="button" class="dropdown-item-v text-danger" v-close-popper @click="handleDeleteGroup">
                                                <i class="ri-delete-bin-line me-2"></i> <span>Apagar grupo</span>
                                            </button>
                                        </template>

                                        <template v-else>
                                            <DropdownField
                                                :distance="-4"
                                                placement="right-start"
                                                :triggers="['click']"
                                                strategy="fixed"
                                                :delay="{ show: 200, hide: 100 }"
                                                interactive
                                            >
                                                <template #default>
                                                    <button type="button" class="dropdown-item-v submenu-trigger">
                                                        <span>Ações de Atendimento</span>
                                                        <i class="ri-arrow-right-s-line"></i>
                                                    </button>
                                                </template>
                                                <template #popper>
                                                    <div class="dropdown-menu-v">
                                                        <li v-permission="'conta.vincular_etiquetas'">
                                                        <button v-if="!isTeamMode" type="button" class="dropdown-item-v" @click="() => { chatStore.setChatToLinkTags(chatStore.activeChat); $emit('open-link-tag-modal') }">
                                                            <i class="ri-price-tag-3-line me-2"></i> <span>Etiquetas</span>
                                                        </button>
                                                        </li>
                                                        <button type="button" class="dropdown-item-v" v-close-popper @click="uiStore.openHistoryModal()">
                                                            <i class="ri-history-line me-2"></i> <span>Histórico</span>
                                                        </button>
                                                        <button v-if="!isTeamMode && !chatIsControlledByAI && atendimentoIsAberto" type="button" class="dropdown-item-v" v-close-popper @click="uiStore.openTransferModal()">
                                                            <i class="ri-arrow-right-line me-2"></i> <span>Transferir Atendimento</span>
                                                        </button>
                                                        <button type="button" class="dropdown-item-v" v-close-popper @click="$emit('forward-mass')">
                                                            <i class="ri-chat-forward-line me-2"></i> <span>Encaminhar</span>
                                                        </button>

                                                        <button v-if="podeMoverQuadro" type="button" class="dropdown-item-v" v-close-popper @click="abrirMoverQuadroModal()">
                                                            <i class="ri-drag-move-2-line me-2"></i> <span>Mover para Quadro</span>
                                                        </button>
                                                    </div>
                                                </template>
                                            </DropdownField>

                                            <DropdownField
                                                :distance="-4"
                                                placement="right-start"
                                                :triggers="['click']"
                                                strategy="fixed"
                                                :delay="{ show: 200, hide: 100 }"
                                                interactive
                                            >
                                                <template #default>
                                                    <li v-permission="'conta.disparar_chatbots'">
                                                        <button type="button" class="dropdown-item-v submenu-trigger">
                                                            <span>Ações de BOT</span>
                                                            <i class="ri-arrow-right-s-line"></i>
                                                        </button>
                                                    </li>
                                                </template>
                                                <template #popper>
                                                    <div class="dropdown-menu-v">
                                                        <button type="button" class="dropdown-item-v" v-close-popper @click="$emit('trigger-bot')">
                                                            <i class="ri-robot-line me-2"></i> <span>Disparar um BOT</span>
                                                        </button>
                                                        <button type="button" class="dropdown-item-v" v-close-popper @click="$emit('stop-bot')">
                                                            <i class="ri-stop-circle-line me-2"></i> <span>Interromper Bot</span>
                                                        </button>
                                                    </div>
                                                </template>
                                            </DropdownField>

                                            <AcoesAxion />

                                            <button v-if="canExportConversa" type="button" class="dropdown-item-v" v-close-popper @click="handleExportConversa" :disabled="isExporting">
                                                <i class="ri-file-download-line me-2"></i> <span>Exportar conversa</span>
                                            </button>

                                            <div class="dropdown-divider-v"></div>

                                            <button v-if="!isTeamMode" type="button" class="dropdown-item-v text-danger" @click="handleFinishChat">
                                                <i class="ri-logout-box-r-line me-2"></i> <span>Finalizar Atendimento</span>
                                            </button>
                                        </template>
                                    </div>
                                </template>
                            </DropdownField>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div v-else class="p-3 p-lg-4 border-bottom user-chat-topbar search-bar-active">
            <div class="d-flex align-items-center w-100">
                <input v-model="searchQuery" @keydown.enter="triggerSearch" type="text" class="form-control form-control-sm bg-light border-light" placeholder="Pesquisar mensagens..." autofocus />
                <span class="search-count text-muted ms-2">{{ searchResultCount.total > 0 ? `${searchResultCount.current} / ${searchResultCount.total}` : '0 / 0' }}</span>
                <button type="button" class="btn nav-btn btn-sm p-0" title="Anterior" :disabled="searchResultCount.total === 0" @click="$emit('search-prev')"><i class="ri-arrow-up-s-line"></i></button>
                <button type="button" class="btn nav-btn btn-sm p-0" title="Próximo" :disabled="searchResultCount.total === 0" @click="$emit('search-next')"><i class="ri-arrow-down-s-line"></i></button>
                <button type="button" class="btn nav-btn btn-sm p-0" title="Fechar Pesquisa" @click="closeSearchMode"><i class="ri-close-line"></i></button>
            </div>
        </div>

        <div v-if="pinnedMessage" class="pinned-message-bar" :class="{ 'pinned-loading': isLoadingPin }">
            <div class="pinned-counter" v-if="chatStore.mensagensFixadas.length > 1">
                <span>{{ currentPinIndex + 1 }}/{{ chatStore.mensagensFixadas.length }}</span>
                <i class="ri-pushpin-fill"></i>
            </div>
            <i v-else class="ri-pushpin-fill pinned-icon"></i>
            <div class="pinned-text" @click="currentPinRecord && goToPinById(currentPinRecord.id)">
                <span class="pinned-owner">{{ getMessageOwnerName(pinnedMessage) }}</span>
                <span class="pinned-snippet">{{ getMessageSnippet(pinnedMessage) }}</span>
            </div>

            <!-- Desafixar: ícone próprio (antes vivia dentro do dropdown de opções). -->
            <button type="button" class="btn btn-pinned-action" title="Desafixar" @click.stop="currentPinRecord && chatStore.unpinMessage(currentPinRecord.id)">
                <i class="ri-unpin-line"></i>
            </button>

            <!-- Ver todas as fixadas: o chevron que antes abria "Desafixar" agora lista todos os pins. -->
            <DropdownField v-if="chatStore.mensagensFixadas.length > 1" :distance="6" placement="bottom-end" strategy="fixed" :triggers="['click']">
                <template #default>
                    <button type="button" class="btn btn-close-pinned" title="Ver todas as mensagens fixadas"><i class="ri-arrow-down-s-line"></i></button>
                </template>
                <template #popper>
                    <div class="dropdown-menu-v pinned-list">
                        <button
                            v-for="pin in pinsMaisRecentesPrimeiro"
                            :key="pin.id"
                            type="button"
                            class="dropdown-item-v pinned-list-item"
                            :class="{ 'pinned-list-item-active': pin.id === currentPinRecord?.id }"
                            @click="goToPinById(pin.id)"
                            v-close-popper
                        >
                            <i class="ri-pushpin-fill me-2 pinned-list-pin"></i>
                            <span class="pinned-list-text">
                                <span class="pinned-owner">{{ pinDisplayOwner(pin) }}</span>
                                <span class="pinned-snippet">{{ pinDisplaySnippet(pin) }}</span>
                            </span>
                            <i class="ri-unpin-line pinned-list-unpin" title="Desafixar" @click.stop="chatStore.unpinMessage(pin.id)"></i>
                        </button>
                    </div>
                </template>
            </DropdownField>
        </div>

        <MoverQuadroModal
            :is-open="showMoverQuadroModal"
            :quadros="quadrosDisponiveis"
            :current-quadro-id="chatStore.activeChat?.idQuadro ?? null"
            :current-quadro-nome="currentQuadroNome"
            :saving="movingQuadro"
            @close="showMoverQuadroModal = false"
            @confirm="moverParaQuadro"
        />
    </div>
</template>

<script setup>
import { computed, reactive, ref, watch } from 'vue';
import { rotuloPresenca, useChatStore } from '@/stores/app/chatStore';
import { useUiStore } from '@/stores/app/uiStore';
import { hideAllPoppers } from 'floating-vue';
import { branding } from '@/config/branding';
import AvatarField from '@/components/global/AvatarField.vue';
import Swal from 'sweetalert2';
import { toast } from 'vue3-toastify';
import { useScheduleStore } from '@/stores/app/scheduleStore';
import { rotuloPresencaChatInterno, useInternalChatStore } from '../../../../stores/app/chatInternoStore';
import { PromptToFinalizarAtendimento } from '../../swal/FinalizarAtendimento';
import { PromptToAlternarSilencioGrupo } from '../../swal/SilenciarGrupo';
import { grupoEstaSilenciado } from '@/stores/app/chatUtils';
import AcoesAxion from './AcoesAxion.vue';
import MoverQuadroModal from '@/components/app/modals/MoverQuadroModal.vue';
import { delay } from '@/utils/delay';
import { cHasAiIntegration } from '@/composables/hasAiIntegration';
import { useContatoStore } from '@/stores/app/contatoStore';
import { useAuthStoreUser } from '@/stores/app/authUser';
import { useLigacoesStore } from '@/stores/app/ligacoesStore';
import { suportaLigacao } from '@/services/inbox/inbox.service';
import { useMoverQuadro } from '@/composables/useMoverQuadro';
import { MensagensService } from '@/services/mensagens/mensagens.service';
import { exportarConversaParaPdf } from '@/utils/exportarConversaPdf';
import { fusosDisponiveis as listarFusosDisponiveis } from '@/utils/fusosHorarios';
const scheduleStore = useScheduleStore();

const __debugForce_showInteractionWindowCountdown = ref(false);

const props = defineProps({
    contact: {
        type: Object,
        default: () => ({ name: 'Carregando...', status: '...', avatar: null, participants: [] })
    },
    searchResultCount: {
        type: Object,
        default: () => ({ current: 0, total: 0 })
    }
});

const isOnline = computed(() => {

    if (!internalChatStore.isInternalChatMode) return false;

    return !!props.contact?.isOnline;
});

const emit = defineEmits([
    'select-messages', 'mute-chat', 'favorite-chat', 'open-link-tag-modal',
    'open-history', 'transfer-chat', 'forward-mass', 'trigger-bot',
    'stop-bot', 'end-session', 'search', 'search-next', 'search-prev', 'search-close'
]);

const chatStore = useChatStore();
const uiStore = useUiStore();
const isTeamMode = computed(() => chatStore.isTeamMode);
const internalChatStore = useInternalChatStore();
const authUserStore = useAuthStoreUser();
const mensagensService = new MensagensService();
const isExporting = ref(false);

// Feature "Mover para Quadro" — lógica compartilhada com o card ChatItem.
const {
    showModal: showMoverQuadroModal,
    moving: movingQuadro,
    quadrosDisponiveis,
    podeMover: podeMoverQuadro,
    currentQuadroNome,
    ensureQuadrosLoaded: ensureQuadrosMoverLoaded,
    abrirModal: abrirMoverQuadroModal,
    moverParaQuadro,
} = useMoverQuadro(() => chatStore.activeChat);

// Exportar conversa: somente para usuários com acesso global, em conversas 1:1 (não grupo/equipe/interno).
const canExportConversa = computed(() =>
    authUserStore.user?.hasGlobalAccess === true
    && !isGroup.value
    && !isTeamMode.value
    && !internalChatStore.isInternalChatMode
);

// Fusos oferecidos no seletor; o do navegador é sempre incluído e pré-selecionado.
const fusosDisponiveis = listarFusosDisponiveis();

const handleExportConversa = async () => {
    if (isExporting.value) return;

    const idInbox = chatStore.activeChat?.idInbox ?? props.contact.idInbox;
    const idContato = props.contact.idContato || props.contact.id;

    if (!idInbox || !idContato) {
        toast.error('Não foi possível identificar o inbox/contato da conversa.');
        return;
    }

    const { value: timeZone } = await Swal.fire({
        title: 'Exportar conversa',
        text: 'Fuso horário para as datas e horas do documento:',
        input: 'select',
        inputOptions: fusosDisponiveis.opcoes,
        inputValue: fusosDisponiveis.padrao,
        showCancelButton: true,
        confirmButtonText: 'Exportar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#075e54',
    });
    if (!timeZone) return; // cancelado

    isExporting.value = true;
    toast.info('Gerando exportação da conversa...');
    try {
        const dados = await mensagensService.exportarConversa(idInbox, idContato);
        if (!dados?.mensagens?.length) {
            toast.warning('Nenhuma mensagem encontrada para exportar.');
            return;
        }
        exportarConversaParaPdf(dados, timeZone);
        toast.success(`Conversa pronta (${dados.total} mensagens). Use o diálogo para salvar em PDF.`);
    } catch (e) {
        toast.error(e instanceof Error ? e.message : 'Falha ao exportar a conversa.');
    } finally {
        isExporting.value = false;
    }
};

const isSearchOpen = ref(false);
const searchQuery = ref('');
let searchTimeout = null;

const countdown = reactive({ show: false, hours: 0, minutes: 0, seconds: 0});
/** Menos de 1h de janela: o contador vira alerta. */
const cswUrgente = computed(() => countdown.show && !countdown.hours);
async function countdownJanelaAtendimento() {
    do {
        // Capacidade Cloud API (WHATSAPP_META ou coexistência híbrida) — a janela
        // existe nos dois, e é ela que decide se ainda dá para responder pela oficial.
        if (!chatStore.inboxOfSelectedChatSuportaTemplatesMeta) {
            return countdown.show = false;
        }

        const lastInteractionMs = new Date(chatStore.activeChat?.lastClientInteraction ?? 0).getTime()
        const currentMs = Date.now();
        const _oneMinuteTolerance = 60 * 1000;
        const _interactionWindowMs = 24 * 3600 * 1000;
        const interactionWindowInsideTolerance = _interactionWindowMs - _oneMinuteTolerance;

        const remainingMs = (lastInteractionMs + interactionWindowInsideTolerance) - currentMs;
        const remainingAsSec = Number.parseInt(`${remainingMs / 1000}`);
        const remainingAsMin = Number.parseInt(`${remainingAsSec / 60}`);
        const remainingAsHours = Number.parseInt(`${remainingAsMin / 60}`);

        if (lastInteractionMs + interactionWindowInsideTolerance < currentMs) {
            return countdown.show = false;
        }

        const hours   = Math.max(remainingAsHours % 24, 0);
        const minutes = Math.max(remainingAsMin % 60, 0);
        const seconds = Math.max(remainingAsSec % 60, 0);

        if (!hours && !minutes && !seconds ) {
            return countdown.show = false;
        }

        countdown.hours   = hours;
        countdown.minutes = minutes;
        countdown.seconds = seconds;
        countdown.show    = true;

        await delay(1000);
    } while (true)
} 
watch(() => props.contact, countdownJanelaAtendimento, { immediate: true })

const handleFinishChat = () => {
    // Usa o chat ativo da store para garantir integridade
    if (chatStore.activeChat) {
        PromptToFinalizarAtendimento(chatStore.activeChat, chatStore);
    } else {
        // Fallback caso use props
        PromptToFinalizarAtendimento({
            id: props.contact.id || props.contact.idContato,
            name: props.contact.name,
            idInbox: props.contact.idInbox // Certifique-se que seu prop contact tem idInbox, senão pegue do activeChat
        }, chatStore);
    }
};

// Correção Lógica: Usa 'props.contact' explicitamente e verifica múltiplas condições
const grupoAtivoSilenciado = computed(() => !!chatStore.activeChat && grupoEstaSilenciado(chatStore.activeChat));

const isGroup = computed(() => {
    return props.contact?.isGroup === true ||
        (props.contact?.id && props.contact.id.toString().includes('@g.us')) ||
        props.contact?.id === 'g1';
});

// ── Ligação de voz ────────────────────────────────────────────────────────────
const ligacoesStore = useLigacoesStore();

const idInboxAtivo = computed(() => chatStore.activeChat?.idInbox ?? props.contact?.idInbox ?? null);

// Mesmo guard do menu de 3 pontinhos da lista (GroupItem). A diretiva v-permission
// só avalia no `mounted`, por isso os elementos guardados usam :key com o idInbox —
// trocar de conversa recria o nó e força a reavaliação da permissão.
const permApagarGrupo = computed(() => ({
    perms: 'inbox.apagar_grupos',
    idInbox: idInboxAtivo.value ?? '',
}));

const inboxDaConversa = computed(() =>
    idInboxAtivo.value
        ? authUserStore.inboxesFull.find(i => i.id === idInboxAtivo.value) ?? null
        : null,
);

/** Número do contato da conversa, em dígitos como o backend espera. */
const numeroDaConversa = computed(() =>
    chatStore.activeChat?.codigoContato ?? props.contact?.codigoContato ?? null,
);

const podeLigar = computed(() =>
    !isGroup.value
    && !isTeamMode.value
    && !internalChatStore.isInternalChatMode
    && !!numeroDaConversa.value
    && !!inboxDaConversa.value?.ligacoesHabilitadas
    && suportaLigacao(inboxDaConversa.value?.plataforma),
);

const discandoNestaInbox = computed(() => !!idInboxAtivo.value && !!ligacoesStore.discando[idInboxAtivo.value]);

/**
 * Disca para o contato da conversa. O card da ligação é do overlay global
 * (`LigacaoOverlay`), não deste header: a chamada sobrevive à troca de
 * conversa, e ficar preso ao chat aberto faria o operador perder o controle de
 * áudio ao clicar em outro atendimento.
 *
 * Amarra a ligação ao atendimento ABERTO (`activeChat.id`) para o histórico
 * ficar na conversa em que o operador está; sem isso o servidor reusaria/criaria
 * outro atendimento do mesmo contato.
 */
const handleLigar = async () => {
    if (!podeLigar.value || discandoNestaInbox.value) return;

    const idAtendimento = chatStore.activeChat?.isGroup ? null : chatStore.activeChat?.id ?? null;
    // Foto do contato do chat ABERTO: é a mesma imagem que o servidor mandaria
    // no evento (o `avatar` do chat vem de `contato.imagem`), só que já em mãos.
    // Sem ela o card nasce com as iniciais e troca para a foto quando o
    // `LIGACAO_ATUALIZADA` chega, piscando na cara de quem discou.
    const imagemContato = chatStore.activeChat?.avatar || null;
    try {
        const idLigacao = await ligacoesStore.discar(
            idInboxAtivo.value,
            numeroDaConversa.value,
            idAtendimento,
            imagemContato,
        );
        if (!idLigacao) return; // discagem já em voo nesta inbox
    } catch (e) {
        // A mensagem do backend é útil ao operador ("número não está no
        // WhatsApp", "você já está em uma ligação"), então vai crua para a tela.
        toast.error(e?.response?.data?.message || e?.message || 'Não foi possível iniciar a ligação.');
    }
};

// 🤖 Badge "IA desativada": conta tem integração de IA em algum inbox, mas o
// contato do atendimento aberto está com o Agente de IA desligado (agenteIaAtivado=false).
const { hasAiIntegration } = cHasAiIntegration();
const contatoStore = useContatoStore();
const contatoIaAtivado = ref(null);

watch(() => props.contact?.idContato || props.contact?.id, async (idContato) => {
    contatoIaAtivado.value = null;
    if (!idContato || isGroup.value) return;
    const c = await contatoStore.findByIdCached(idContato);
    contatoIaAtivado.value = c?.agenteIaAtivado ?? null;
}, { immediate: true });

const showNoAiBadge = computed(() =>
    hasAiIntegration.value &&
    !isGroup.value &&
    !internalChatStore.isInternalChatMode &&
    contatoIaAtivado.value === false
);

// "escrevendo..." / "Ana está escrevendo...". Assume o lugar da linha de status
// enquanto alguém digita — mesma posição em atendimento, grupo e chat interno, que
// compartilham este header. No chat interno cobre o Online/Offline: digitando já
// implica online, e a informação mais específica ganha.
const presencaDigitando = computed(() => {
    if (internalChatStore.isInternalChatMode) {
        const texto = rotuloPresencaChatInterno(internalChatStore.activeChatId);
        return texto ? { texto, cor: null } : null;
    }
    return rotuloPresenca(chatStore.chatList.find(c => c.id === props.contact?.id), chatStore.contatosByCodigo);
});

// Resumo dos participantes para exibir no header (ex: "Você, Miller, Geovana...")
const groupParticipantsSummary = computed(() => {
    // No subgrupo de avisos a lista de participantes não descreve o grupo: quem está
    // ali é a comunidade inteira, e o WhatsApp anonimiza os membros comuns — o
    // subtítulo viraria uma enumeração de nomes ofuscados sugerindo ser "os
    // participantes deste grupo". Melhor dizer o que o grupo É.
    if (props.contact?.ehGrupoAvisos) {
        const nomeComunidade = props.contact.comunidade?.nome;
        return nomeComunidade ? `Avisos de ${nomeComunidade}` : 'Avisos da comunidade';
    }

    if (!props.contact?.participants) return '';
    const names = props.contact.participants.map(p => p.name);
    return names.join(', ');
});

const handleVideoCall = () => toast.info('Iniciando sala de vídeo...');
const openBlockModal = () => uiStore.openGroupBanModal();

const isDeletingGroup = ref(false);

const handleDeleteGroup = async () => {
    if (isDeletingGroup.value) return;

    // Grupo != atendimento: o id do grupo vem do chat ativo (mesma origem usada
    // pelo menu de 3 pontinhos da lista), com fallback para a prop.
    const idGrupo = chatStore.activeChat?.id ?? props.contact?.id;
    const idInbox = chatStore.activeChat?.idInbox ?? props.contact?.idInbox;

    if (!idGrupo || !idInbox) {
        toast.error('Não foi possível identificar o grupo.');
        return;
    }

    const result = await Swal.fire({
        title: 'Apagar Grupo?',
        text: "Você tem certeza que deseja apagar este grupo?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Sim, apagar',
        cancelButtonText: 'Cancelar'
    });

    if (!result.isConfirmed) return;

    isDeletingGroup.value = true;
    try {
        // Mesma ação do menu de 3 pontinhos da lista (GroupItem.apagarGrupo).
        // deleteGroup já emite os toasts de sucesso/erro.
        await chatStore.deleteGroup(idGrupo, idInbox);
    } finally {
        isDeletingGroup.value = false;
    }
};

const openSearchMode = () => isSearchOpen.value = true;
const closeSearchMode = () => {
    isSearchOpen.value = false;
    searchQuery.value = '';
    emit('search-close');
};

const triggerSearch = () => {
    const term = searchQuery.value.trim();
    if (term) emit('search', term);
    else emit('search-close');
};

watch(searchQuery, (newVal) => {
    if (!newVal || newVal.trim() === '') {
        emit('search-close');
        return;
    }
    if (searchTimeout) clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => triggerSearch(), 500);
});

const currentPinIndex = ref(0);
watch(() => chatStore.activeChatId, () => { currentPinIndex.value = 0; });
watch(() => chatStore.mensagensFixadas.length, (len) => {
    if (currentPinIndex.value >= len) currentPinIndex.value = Math.max(0, len - 1);
});

const currentPinRecord = computed(() => chatStore.mensagensFixadas[currentPinIndex.value] ?? null);

// Resolve o registro de pin para a mensagem carregada (se estiver na janela) ou
// um objeto sintético a partir dos metadados do pin. Compartilhado pela barra e
// pela lista de "todas as fixadas".
const pinToMessage = (pin) => {
    if (!pin) return null;
    const loaded = chatStore.messages.find(m => m.id === pin.idMensagem);
    if (loaded) return loaded;
    return { id: pin.idMensagem, text: pin.texto, type: pin.tipo, isSent: false, isBot: false };
};

const pinnedMessage = computed(() => pinToMessage(currentPinRecord.value));

const pinDisplayOwner = (pin) => getMessageOwnerName(pinToMessage(pin));
const pinDisplaySnippet = (pin) => getMessageSnippet(pinToMessage(pin));

// Lista exibida do mais RECENTE para o mais antigo: o pin recente costuma já
// estar na janela carregada → salto instantâneo. Os antigos (fundo do histórico)
// exigem paginação e por isso ficam embaixo. `mensagensFixadas` vem `dataMensagem asc`.
const pinsMaisRecentesPrimeiro = computed(() => [...chatStore.mensagensFixadas].slice().reverse());

// Vai direto ao pin escolhido (lista ou barra) e o marca como atual, sem ciclar.
const goToPinById = async (pinId) => {
    const idx = chatStore.mensagensFixadas.findIndex(p => p.id === pinId);
    if (idx < 0) return;
    currentPinIndex.value = idx;
    await navigateToPinnedMessage(chatStore.mensagensFixadas[idx].idMensagem);
};

const getMessageOwnerName = (message) => {
    if (!message) return '';
    if (message.isSent) return 'Você';
    if (message.isBot) return 'Bot';
    return chatStore.activeChat?.name || 'Contato';
};
const TYPE_LABEL = {
    // backend Cassandra values (uppercase)
    audio: 'Áudio',       AUDIO: 'Áudio',
    IMAGEM: '📷 Imagem',  VIDEO: '📹 Vídeo',
    DOCUMENTO: '📄 Documento', FIGURINHA: '🎭 Figurinha',
    LOTTIE: '📷 Imagem',  LOCALIZACAO: '📍 Localização',
    CONTATO: '👤 Contato', CONTATOS: '👥 Contatos',
    ENQUETE: '📊 Enquete', INTERATIVA: '🔘 Botão',
    PIX: '💸 Pix',        EVENTO: 'Evento',
    LISTA: 'Lista',        LISTA_RESPOSTA: 'Resposta a lista',
    CONVITE_GRUPO: 'Convite para grupo', GENERICA: 'Mensagem',
    VISUALIZACAO_UNICA: '🔒 Visualização única',
    NAO_SUPORTADA: '⚠️ Mensagem não suportada',
    // frontend Message.type values (lowercase)
    imagem: '📷 Imagem',  video: '📹 Vídeo',
    file: '📄 Documento', sticker: '🎭 Figurinha',
    location: '📍 Localização', contact: '👤 Contato',
    multi_contact: '👥 Contatos', poll: '📊 Enquete',
    event: 'Evento',      list: 'Lista',
    'list-answer': 'Resposta a lista',
    'group-invite': 'Convite para grupo',
    template_meta: 'Template',
};
const getMessageSnippet = (message) => {
    if (!message) return '';
    if (message.text) return message.text;
    return TYPE_LABEL[message.type] ?? 'Mensagem';
};
const isLoadingPin = ref(false);
const MAX_PIN_FETCHES = 10;

const navigateToPinnedMessage = async (idMensagem) => {
    if (isLoadingPin.value) return false;
    isLoadingPin.value = true;
    try {
        for (let i = 0; i <= MAX_PIN_FETCHES; i++) {
            if (chatStore.messages.find(m => m.id === idMensagem)) {
                uiStore.scrollToMessage(idMensagem);
                return true;
            }
            const { messages: fetched, hasMore } = await chatStore.fetchNextPage();
            if (!fetched?.length || !hasMore) break;
        }
        toast.warning('Mensagem não encontrada no histórico.');
        return false;
    } finally {
        isLoadingPin.value = false;
    }
};

const handleDropdownOpen = () => {
    hideAllPoppers();
    // Pré-carrega os quadros para o item "Mover para Quadro" já aparecer no 1º open.
    ensureQuadrosMoverLoaded();
};
const displayAvatar = computed(() => {
    const c = props.contact;
    if (!c) return null;

    if (c.avatar && c.avatar.length > 5) {
        return c.avatar;
    }

    return isGroup.value ? branding.images.avatarFallbackGroup : branding.images.avatarFallback;
});

const __debugForceChatControlledByAI = ref(false);
const chatIsControlledByAI = computed(() => {
    if (__debugForceChatControlledByAI.value) return true;
    if (internalChatStore.isInternalChatMode) return false;

    return !!chatStore.activeChat?.idChatBotIa && chatStore.activeChat?.statusIntegracaoIa != 'EM_ATENDIMENTO_HUMANO'
})

/**
 * Menu "Mais Opcoes" do cabecalho. Atendimento conduzido pelo Agente de IA
 * exige `inbox.intervir_atendimentos_agente` no inbox do chat aberto;
 * atendimento comum segue liberado.
 *
 * Usa o predicado do store (`chatEhConduzidoPorIa`) e nao o
 * `chatIsControlledByAI` local: este ultimo tem o override de debug e trata
 * `statusIntegracaoIa` de forma mais frouxa, o que faria o cabecalho e o card
 * da lista discordarem sobre o mesmo atendimento.
 */
const podeIntervirNoAgente = computed(() =>
    chatStore.podeIntervirNoAtendimentoDoAgente(chatStore.activeChat)
);

const atendimentoIsAberto = computed(() => {
    return chatStore.activeChat.status == 'Aberto'
})
</script>

<style scoped>
/* Classe própria em vez de `.text-success`: aquela regra do bootstrap.min.css é
   `!important`, e declaração `!important` de folha de estilo vence style inline
   normal — a cor pastel do autor era calculada e silenciosamente descartada. */
.presenca-header {
    color: var(--bs-success);
}

/*
   Contador da janela de atendimento. Era um badge vermelho sólido que competia
   com o nome do contato; virou pílula sutil, alinhada aos ícones do header, e
   só fica vermelha quando resta menos de 1h.
*/
.csw-timer {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    height: 30px;
    padding: 0 10px;
    margin-right: 0.5rem;
    border-radius: 999px;
    background-color: var(--bs-light);
    border: 1px solid var(--bs-border-color-translucent);
    color: var(--bs-text-muted);
    font-size: 12px;
    font-weight: 600;
    line-height: 1;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
    transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}

.csw-timer i { font-size: 14px; }
.csw-timer-value { letter-spacing: 0.2px; }

.csw-timer.is-urgent {
    background-color: var(--bs-danger-bg-subtle, #f8d7da);
    border-color: var(--bs-danger-border-subtle, #f1aeb5);
    color: var(--bs-danger, #dc3545);
}

[data-bs-theme="dark"] .csw-timer {
    background-color: rgba(255, 255, 255, 0.06);
    border-color: rgba(255, 255, 255, 0.1);
}

/* (Mantenha o CSS original do seu arquivo, ele está correto) */
.user-chat-topbar-wrapper { position: relative; z-index: 2; flex-shrink: 0; }
.user-chat-topbar { background-color: var(--bs-white); border-bottom: 1px solid #ffa4bf12 !important; min-height: 73px; flex-shrink: 0; position: relative; z-index: 2; }
.user-chat-nav { display: flex; justify-content: flex-end; align-items: center; }
.user-chat-nav .btn.nav-btn { height: 40px; width: 40px; line-height: 40px; padding: 0; font-size: 22px; color: var(--bs-text-muted); border-radius: 50%; transition: background-color 0.2s ease; }
.user-chat-nav .btn.nav-btn:hover { background-color: var(--bs-light); color: var(--bs-dark); }
.name_header { color: var(--bs-dark); font-weight: 500; }
.dropdown-toggle::after { display: none; }
.pinned-message-bar { display: flex; align-items: center; justify-content: space-between; padding: 10px 1.5rem; background-color: var(--bs-white); box-shadow: var(--bs-box-shadow); z-index: 2; cursor: pointer; transition: background-color 0.15s ease; gap: 12px; }
.pinned-message-bar:hover { background-color: var(--bs-light); }
.pinned-loading { opacity: 0.6; cursor: wait; pointer-events: none; }
.pinned-icon { font-size: 16px; color: var(--bs-text-muted); flex-shrink: 0; }
.pinned-counter { display: flex; flex-direction: column; align-items: center; gap: 2px; flex-shrink: 0; font-size: 11px; font-weight: 600; color: var(--bs-primary); line-height: 1; }
.pinned-counter i { font-size: 14px; }
.pinned-text { display: flex; flex-direction: column; overflow: hidden; flex: 1; }
.pinned-text { display: flex; flex-direction: column; overflow: hidden; }
.pinned-owner { font-size: 14px; font-weight: 600; color: var(--bs-primary); }
[data-bs-theme=dark] .pinned-owner { color: var(--brand-pinned-owner-color); }
.pinned-snippet { font-size: 14px; color: var(--bs-text-muted); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.btn-close-pinned { font-size: 20px; opacity: 0.6; color: var(--bs-text-muted); background: transparent; border: none; padding: 0; line-height: 1; }
.btn-close-pinned:hover { opacity: 1; }
:deep(.dropdown-menu-v) { max-height: 90vh; overflow-y: auto; }

/* Lista de todas as mensagens fixadas */
.pinned-text { flex: 1; min-width: 0; cursor: pointer; }
.btn-pinned-action { font-size: 18px; opacity: 0.6; color: var(--bs-text-muted); background: transparent; border: none; padding: 0 2px; line-height: 1; flex-shrink: 0; }
.btn-pinned-action:hover { opacity: 1; color: var(--bs-danger); }
.pinned-list { min-width: 280px; max-width: 360px; max-height: 45vh; overflow-y: auto; }
.pinned-list-item { display: flex; align-items: center; gap: 4px; width: 100%; text-align: left; }
.pinned-list-item-active { background-color: var(--bs-light); }
.pinned-list-pin { font-size: 14px; color: var(--bs-primary); flex-shrink: 0; }
.pinned-list-text { display: flex; flex-direction: column; overflow: hidden; flex: 1; min-width: 0; }
.pinned-list-text .pinned-owner,
.pinned-list-text .pinned-snippet { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.pinned-list-text .pinned-owner { font-size: 13px; }
.pinned-list-text .pinned-snippet { font-size: 13px; }
.pinned-list-unpin { font-size: 16px; color: var(--bs-text-muted); opacity: 0.6; flex-shrink: 0; padding: 2px; }
.pinned-list-unpin:hover { opacity: 1; color: var(--bs-danger); }
.submenu-trigger { display: flex !important; justify-content: space-between !important; align-items: center !important; }
.search-bar-active { background-color: var(--bs-white); min-height: 73px; display: flex; align-items: center; }
.search-bar-active .form-control { flex-grow: 1; border-radius: 1rem; background-color: var(--bs-light); }
.search-bar-active .search-count { white-space: nowrap; min-width: 50px; text-align: center; }
.search-bar-active .btn.nav-btn.btn-sm { height: 32px; width: 32px; line-height: 32px; font-size: 20px; color: var(--bs-text-muted); margin-left: 4px; border-radius: 1rem; }

.icon-hover-effect { transition: transform 0.2s; }
.icon-hover-effect:hover { transform: scale(1.1); }


.icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    transition: background 0.2s;
}
.icon-container:hover {
    background: rgba(0,0,0,0.04);
}
[data-bs-theme="dark"] .icon-container:hover {
    background: rgba(255,255,255,0.05);
}

.no-ai-badge {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background-color: #fdecef;
    color: #e0466e;
    cursor: default;
    flex-shrink: 0;
}
[data-bs-theme="dark"] .no-ai-badge {
    background-color: rgba(224, 70, 110, 0.16);
    color: #f16f90;
}

.pulse-ring {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 2px solid var(--bs-primary);
    animation: pulse-animation 2s infinite;
    opacity: 0;
    pointer-events: none;
}

@keyframes pulse-animation {
    0% { transform: translate(-50%, -50%) scale(0.8); opacity: 0.5; }
    100% { transform: translate(-50%, -50%) scale(1.5); opacity: 0; }
}

.text-primary { color: var(--bs-primary) !important; }
</style>
